const cache = new Map();

export default {
  get: (key) => cache.get(key),
  set: (key, val) => cache.set(key, val),
  delete: (key) => cache.delete(key),
  clear: () => cache.clear(),
  size: () => cache.size,
};
